import { render, staticRenderFns } from "./YoutubeWithDesc.vue?vue&type=template&id=8fd05e44&scoped=true&"
import script from "./YoutubeWithDesc.vue?vue&type=script&lang=js&"
export * from "./YoutubeWithDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd05e44",
  null
  
)

export default component.exports